import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../app/store";
import { useEffect, useRef, useState } from "react";
import { formatMoeda, getUuidV4, handleNumberOnly, isNumber } from "../../../../utils/utils";
import { removeNFe, addNFe, updateNFe } from "../../../../features/manifestoSlice"
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faPlus, faSave, faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";
import { JConfirmDelete, MensagemModal } from "../../../../components/Components";
import { infMunDescargaInterface, infNFesInterface, SelectObjectRemoveInterface } from "../../../../interfaces";
import NFesProdutoPerigoso from "./NFesProdutoPerigoso";
import NFesUnidadeTransp from "./NFesUnidadeTransp";
import { Link } from "react-router-dom";

const initialForm: infNFesInterface = {
    chNFe: '',
    SegCodBarra: '',
    municipio_id: 0,
    name: '',
    indReentrega: false,
    peri: [],
    infUnidTransp: [],
    id: 0
}

const initialSelect: SelectObjectRemoveInterface = {
    id: 0,
    title: ''
}

const LIMITE: number = 10000;

const NFes: React.FC = () => {
    const dispatch = useDispatch();
    const [notaFiscal, setNotaFiscal] = useState<infNFesInterface>(initialForm);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [selected, setSelected] = useState<SelectObjectRemoveInterface>(initialSelect);
    const [messageAlert, setMessageAlert] = useState<string>('');
    const [showProdutoPerigoso, setShowProdutoPerigoso] = useState<boolean>(false);
    const [change, setChange] = useState<boolean>(false);
    const munNFeSelectRef = useRef<HTMLSelectElement>(null);
    const manifesto = useSelector((state: RootState) => state.manifesto.manifesto);
    const munDescarga = useSelector((state: RootState) => state.manifesto.manifesto.infMunDescarga);
    const selectMunicipiosDescarregamento = useSelector((state: RootState) => 
        state.manifesto.selectMunicipiosDescarregamentos);

    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const handleNFeChange = (e: any) => {
        const { name, value } = e.target;
        setNotaFiscal((prev) => ({ ...prev, [name]: value }))
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(initialSelect);
    }

    const handleOpenModal = (value: SelectObjectRemoveInterface) => {
        if (change) {
            alerta('Existem alterações não salvas.');
            return;
        } 
        setSelected(value);
        setShowModal(true);
    }

    const validaPreenchimentoNFe = () => {
        if (notaFiscal.chNFe === "") {
            alerta('Informe uma chave NFe.');
            return false;
        }

        if (!isNumber(notaFiscal.chNFe)) {
            alerta('Chave NF-e aceita somente números.');
            return false;
        }

        if (notaFiscal.SegCodBarra?.trim() !== "") {
            if (!isNumber(notaFiscal.SegCodBarra?.trim().toString())) {
                alerta('Seg. Cod. Barras aceita somente números.');
                return false;
            }
        }

        if (notaFiscal.chNFe.substring(20, 22) !== '55') {
            alerta('Chave informada não é uma NF-e.');
            return false;
        }

        if (notaFiscal.chNFe.length !== 44) {
            alerta('Chave deve conter 44 caracteres.');
            return false;
        }

        if (munDescarga.flatMap((item: any) => item.infNFe).find((item: infNFesInterface) => 
                item.chNFe === notaFiscal.chNFe && item.id !== notaFiscal.id)) {
            alerta('Chave já foi adicionada.');
            return false;
        }

        if (munDescarga.flatMap(item => item.infNFe).length >= LIMITE) {
            alerta(`Limite de ${formatMoeda(LIMITE, 0)} NF-e atingido.`);
            return false;
        }

        setMessageAlert('')
        setShowAlert(false)
        return true;
    }

    const handleRemover = (value: SelectObjectRemoveInterface) => {
        dispatch(removeNFe({ municipio_id: parseInt(value.id.toString()), chNFe: value.title }));
        setShowModal(false);
    }

    const handleAdd = () => {

        if (munNFeSelectRef.current && munNFeSelectRef.current?.value !== "") {
            const nomeMunicipio = munNFeSelectRef.current?.options[munNFeSelectRef.current?.selectedIndex].text || ''

            if (validaPreenchimentoNFe()) {

                dispatch(addNFe({
                    ...notaFiscal,
                    id: getUuidV4(),
                    name: nomeMunicipio,
                    municipio_id: parseInt(munNFeSelectRef.current?.value)
                }));

                setNotaFiscal(initialForm);
                setShowProdutoPerigoso(false);
            }

        } else {
            alerta("Selecione um município.");
            return;
        }
    }

    const loadNFe = (municipio_id: number, chNFe: string) => {
        if (change) {
            alerta('Existem alterações não salvas.');
            return;
        } else {
            const municipio = manifesto.infMunDescarga.find((item: any) => item.municipio_id === municipio_id);
            const nfe = municipio?.infNFe?.find((item: infNFesInterface) => item.chNFe === chNFe);
            setNotaFiscal({ ...notaFiscal, ...nfe, municipio_id: municipio_id, name: municipio?.name });
            setChange(true);
            if (nfe) {
                if (nfe.peri?.length > 0) {
                    setShowProdutoPerigoso(true);
                }
            }
        }
    }

    const handleUpdateNFe = () => {

        if (validaPreenchimentoNFe()) {
            dispatch(updateNFe({
                ...notaFiscal,
                name: munNFeSelectRef.current?.options[munNFeSelectRef.current?.selectedIndex].text || ''
            }));
            setNotaFiscal(initialForm);
            setChange(false);
            setShowProdutoPerigoso(false);
        }
    }

    useEffect(() => {
        if (munDescarga?.length > 0) {
            setNotaFiscal((prev) =>( {...prev, municipio_id: munDescarga[0].municipio_id}))
        }
  
    }, [munDescarga, manifesto.modal]);

    return (<>
        <Row className="mb-3">
            <Col md>
                <Row className="g-2 mb-3">
                    <Col md={4}>
                        <Form.Group >
                            <Form.Label>*Municipios</Form.Label>
                            <Form.Select name="municipio_id" value={notaFiscal.municipio_id}
                                onChange={handleNFeChange} ref={munNFeSelectRef}>
                                {selectMunicipiosDescarregamento?.map(item => {
                                    return (<option key={item.id} value={item.id}>{item.name}</option>);
                                })}
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group >
                            <Form.Label>*Chave NF-e</Form.Label>
                            <Form.Control name="chNFe" value={notaFiscal.chNFe}
                                onKeyUp={handleNumberOnly} type="text" maxLength={44}
                                // disabled={checkProdutoPerigoso()} 
                                onChange={handleNFeChange} />
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="g-2 mb-3">
                    <Col md>
                        <Form.Group >
                            <Form.Label>Seg. Cod. Barras</Form.Label>
                            <Form.Control name="SegCodBarra" value={notaFiscal.SegCodBarra} maxLength={36}
                                onKeyUp={handleNumberOnly} type="text" onChange={handleNFeChange} />
                        </Form.Group>
                    </Col>
                    <Col md={'auto'} className="d-flex align-items-end ">
                        <Form.Group controlId="active">
                            <Form.Switch className="mb-0" type="switch" name="active" label="ind. Reentrega?"
                                checked={notaFiscal.indReentrega}
                                onChange={(e) => setNotaFiscal({ ...notaFiscal, indReentrega: e.target.checked })} />
                        </Form.Group>
                    </Col>
                    <Col md={'auto'} className="d-flex align-items-end ">
                        <Form.Group controlId="active">
                            <Form.Switch className="mb-0" type="switch" name="opcoes" label="+Opções" 
                                checked={showProdutoPerigoso}
                                title="Adicionar informações de produto perigoso e unidades de transporte"
                                onChange={(e) => setShowProdutoPerigoso(e.target.checked)} />
                        </Form.Group>
                    </Col>

                </Row>

                <Row className="g-2">
                    {change ? (<>
                        <Col md={'auto'} className="d-flex align-items-end">
                            <Button variant="success" onClick={handleUpdateNFe}>
                                <FontAwesomeIcon icon={faSave} /> Salvar
                            </Button>
                        </Col>
                        <Col md={'auto'} className="d-flex align-items-end">
                            <Button variant="secondary" onClick={() => {
                                setChange(false);
                                setShowProdutoPerigoso(false);
                                setNotaFiscal(initialForm);
                            }}>
                                <FontAwesomeIcon icon={faXmark} /> Cancalar
                            </Button>
                        </Col>
                    </>) : (
                        <Col md={'auto'} className="d-flex align-items-end">
                            <Button variant="primary" onClick={handleAdd}>
                                <FontAwesomeIcon icon={faPlus} /> Adicionar
                            </Button>
                        </Col>
                    )
                    }
                </Row>
            </Col>
            {showProdutoPerigoso && (

                <Col md={7} className="border-start">
                    <div className="nav nav-underline" id="v-pills-tab-produto-perigoso" role="tablist">
                        <button className="nav-link active" id="tabpp1-tab" data-bs-toggle="pill" 
                            data-bs-target="#tabpp1" type="button" role="tab"
                            >Produto Perigoso ONU (Opcional)</button>
                        <button className="nav-link" id="tabpp2-tab" data-bs-toggle="pill" data-bs-target="#tabpp2"
                            type="button" role="tab">Inf. Unidades de Transporte (Opcional)</button>

                    </div>
                    <div className="tab-content pt-2 px-2" id="v-pills-tabContentpp">
                        <div className="tab-pane fade show active" id="tabpp1" role="tabpanel">
                            <NFesProdutoPerigoso notaFiscal={notaFiscal} setNotaFiscal={setNotaFiscal} />
                        </div>
                        <div className="tab-pane fade" id="tabpp2" role="tabpanel" >
                            <NFesUnidadeTransp notaFiscal={notaFiscal} setNotaFiscal={setNotaFiscal}/>
                        </div>
                    </div>
                </Col>
            )}
            
        </Row>

        <h6 className=" my-3"><span className="text-dark">(10.000 no máximo)</span></h6>
        <Table striped bordered hover size="sm">
            <thead className="table-light">
                <tr>
                    <th className="text-center" style={{ width: '4rem' }}>#</th>
                    <th>Municipio</th>
                    <th>Chave NF-e</th>
                    <th>Seg. Cod. Barras</th>
                </tr>
            </thead>
            <tbody>
                {munDescarga?.map((item: infMunDescargaInterface) => (
                    <>
                        {item.infNFe?.map((nfe: infNFesInterface) => {
                            return (
                                <tr key={item?.municipio_id}>
                                    <td className="d-flex justify-content-around ">
                                        <Link to={''} className="text-danger"
                                            onClick={() =>
                                                handleOpenModal({ id: item.municipio_id, title: nfe?.chNFe})
                                            }
                                        >
                                            <FontAwesomeIcon icon={faTrash} />
                                        </Link>
                                        <Link to={''} className="text-success" title="Editar"
                                            onClick={() =>
                                                loadNFe(item.municipio_id, nfe?.chNFe)
                                            }
                                        >
                                            <FontAwesomeIcon icon={faPencil} />
                                        </Link>
                                        
                                    </td>
                                    <td>{item.name}</td>
                                    <td>{nfe.chNFe}</td>
                                    <td>{nfe?.SegCodBarra}</td>

                                </tr>
                            )
                        })}
                    </>
                ))}
            </tbody>
        </Table>
        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemover}
            selectedObject={selected.title}
            id={selected}
        />

        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />
    </>)
}

export default NFes;
